module.exports = {"clientVersion":1,"clientPlatform":"web","apiUrl":"/api/v1","verifyCountDown":240,"defaultTitle":"TeleCardio","fakeBackend":false};


//////////////////
// WEBPACK FOOTER
// external "{\"clientVersion\":1,\"clientPlatform\":\"web\",\"apiUrl\":\"/api/v1\",\"verifyCountDown\":240,\"defaultTitle\":\"TeleCardio\",\"fakeBackend\":false}"
// module id = IkUC
// module chunks = 2